import { useTranslation } from "react-i18next";
import { Box, Checkbox, Flex, Grid, Text } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

import { FormItem } from "../../../FormItem";

export interface CampaignInquiryPricingProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryPricing = ({ campaignInquiry }: CampaignInquiryPricingProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Grid>
            <Grid.Col xs={12} sm={6} md={6}>
                <Flex>
                    <Box w="auto" mr="sm">
                        <Checkbox
                            label={t("campaign_pricing_isfree")}
                            checked={campaignInquiry?.pricing?.isFree}
                            disabled
                            onChange={() => {}}
                        />
                    </Box>
                    <Box style={{ flex: 1 }}>
                        <FormItem label={t("campaign_pricing_discount")}>
                            {typeof campaignInquiry?.pricing?.discountPercent === "number" ? (
                                `${campaignInquiry.pricing.discountPercent}%`
                            ) : (
                                <Text color="dimmed">-</Text>
                            )}
                        </FormItem>
                    </Box>
                </Flex>
            </Grid.Col>
        </Grid>
    );
};
